import { TGraphicDesignLessonConfig, TGDRule, TGDRuleSpec } from
  '../../../../models/courses/graphicDesign';

const select = (value: string) => ({ by: 'text' as const, value });
const rule = (id: string, tier: TGDRule['tier'], label: string,
  fail: string, spec: TGDRuleSpec): TGDRule => ({ ...spec, id, tier,
    label: { fr: label }, failMessage: { fr: fail } });

export const MISSION_03_SAMPLE: TGraphicDesignLessonConfig = {
  exerciseType: 'CREATE',
  brief: {
    fr: 'Le Café Tensift ouvre samedi à 14h, rue Tensift. Karim veut une affiche ' +
      'qu’on comprend en 2 secondes depuis le trottoir.',
    en: 'Café Tensift opens Saturday at 2pm on Rue Tensift. Karim wants a poster ' +
      'people understand at a glance.',
    ar: 'يفتح مقهى تنسيفت يوم السبت الساعة الثانية ' +
      'بشارع تنسيفت. يريد كريم ملصقًا واضحًا من بعيد.',
  },
  clientName: 'Karim',
  artboard: { width: 600, height: 800 }, background: '#fff6e8',
  allowedTools: ['shape', 'pictogram', 'text', 'palette'],
  lockedPalette: ['#1f2a37', '#c2410c', '#fff6e8', '#0e7490'],
  rules: [
    rule('r1', 'required', 'Le jour est écrit', 'Karim veut savoir quel jour venir !',
      { type: 'requiredElement', params: { select: select('samedi') } }),
    rule('r2', 'required', 'L’heure est écrite', 'Karim veut connaître l’heure !',
      { type: 'requiredElement', params: { select: select('14h') } }),
    rule('r3', 'required', 'L’adresse est écrite', 'Karim doit indiquer l’adresse.',
      { type: 'requiredElement', params: { select: select('tensift') } }),
    rule('r4', 'required', 'Le titre se lit sur le fond', 'Renforce le contraste du titre.',
      { type: 'contrastMin', params: { a: select('samedi'),
        b: { by: 'background' }, value: 4.5 } }),
    rule('r5', 'required', 'On lit d’abord le jour', 'Agrandis le jour pour guider le regard.',
      { type: 'hierarchyOrder', params: { order: [select('samedi'),
        select('14h'), select('tensift')] } }),
    rule('r6', 'constraint', '3 couleurs maximum', 'Simplifie la palette à trois couleurs.',
      { type: 'maxColors', params: { value: 3, includeBackground: true } }),
    rule('r7', 'constraint', '8 éléments maximum', 'Retire un élément superflu.',
      { type: 'elementCountMax', params: { value: 8 } }),
    rule('r8', 'bonus', 'Jour 2× plus grand que l’adresse', 'Agrandis le jour.',
      { type: 'sizeRatioMin', params: { a: select('samedi'),
        b: select('tensift'), value: 2 } }),
    rule('r9', 'bonus', 'Livré en moins de 8 min', 'Décide plus vite la prochaine fois.',
      { type: 'timeMax', params: { seconds: 480 } }),
  ],
  requiredRules: 4,
  hints: [
    { fr: 'Regarde ton affiche de loin : qu’est-ce que tu lis en premier ?',
      en: 'Look at your poster from afar: what do you read first?',
      ar: 'انظر إلى ملصقك من بعيد: ماذا تقرأ أولًا؟' },
    { fr: 'Le jour doit être le plus gros texte, au moins deux fois plus grand que l’adresse.',
      en: 'The day should be the largest text, at least twice the size of the address.',
      ar: 'يجب أن يكون اليوم أكبر نص، ضعف حجم العنوان على الأقل.' },
    { fr: 'Mets « Samedi » en 72, « 14h » en 40, « Rue Tensift » en 20, ' +
        'texte foncé sur fond clair.',
      en: 'Set Saturday to 72, 2pm to 40, and Rue Tensift to 20, with dark text on a light background.',
      ar: 'اكتب السبت بحجم 72 والساعة الثانية بحجم 40 ' +
        'وشارع تنسيفت بحجم 20 بنص داكن.' },
  ],
  reward: { unlockTool: 'layers', atStars: 2 },
  solution: { background: '#fff6e8', components: [
    { id: 'c1', type: 'text', text: 'Samedi', x: 48, y: 96, width: 420, height: 80,
      fontSize: 72, fill: '#1f2a37', layer: 3, rotation: 0 },
    { id: 'c2', type: 'text', text: '14h', x: 48, y: 190, width: 200, height: 48,
      fontSize: 40, fill: '#c2410c', layer: 3, rotation: 0 },
    { id: 'c3', type: 'text', text: 'Rue Tensift', x: 48, y: 250, width: 300, height: 30,
      fontSize: 20, fill: '#1f2a37', layer: 3, rotation: 0 },
    { id: 'c4', type: 'pictogram', icon: 'tabler:coffee', x: 380, y: 540,
      width: 160, height: 160, fill: '#c2410c', layer: 2, rotation: 0 },
    { id: 'c5', type: 'shape', sides: 0, x: 420, y: 40, width: 160,
      height: 160, fill: '#c2410c', layer: 1, rotation: 0 },
  ] },
};
